import React from "react";

const terminateWhenFlatDoc = (
    <>
        <p>
            By default, the trade plan will terminate once the position being traded
            closes. Unchecking this setting will prevent that. We will wait till all entry and
            position tactics are hit.
        </p>
        <p>
            Ex: Let's say a user sets a bounce with scaling in at 449.5 at 450 on AAPL, and the bounce results in an
            exit tactic at 449.75. By default the system
            will terminate then. Another example could be bounce at 450, into a market order and candle
            break, with the candle break being confirmation of the bounce. If the first position from the market order
            closes, perhaps you will want to wait to buy on a candle break anyways. If this is unchecked, the system
            will continue waiting until price hits
            449.75.
        </p>
        <p>
            NOTE: use this with caution, as it will wait for every entry and position
            tactic to hit, which might occur much later on. It could be smarter to let the trade plan finish, and start
            another one with bounce at 449.5
        </p>
    </>
);

export default terminateWhenFlatDoc;
